<template>
    <div class="flex flex-col min-h-screen overflow-x-clip">
        <slot />
        <slot name="popup" />
        <slot name="navigation" />
        <slot name="banner" />
        <slot name="blocks" />
        <div class="mt-auto">
            <slot name="pre-footer" />
            <slot name="footer" />
        </div>
    </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>

</style>